import AbstractStore from '../../Common/Stores/AbstractStore';

export class CompareStore extends AbstractStore {
    constructor() {
        super(['add', 'remove', 'load', 'error', 'clearError']);

        this.state = {products: [], matrix: [], error: null};
    }

    load(data) {
        this.actions.load(data);
    }
    add(product, matrix) {
        this.actions.add(product, matrix);
    }
    remove(product) {
        this.actions.remove(product);
    }
    error(message) {
        this.actions.error(message);
    }
    clearError() {
        this.actions.clearError();
    }

    onLoad(data) {
        this.state = Object.assign({}, data, {error: null});

        this.trigger(this.state);
    }

    onAdd(product, matrix) {
        if (!this.state.products.some(currentValue => currentValue.id === product.id)) {
            this.state.products.push(product);
        }
        this.state.matrix = matrix;
        this.state.error = null;

        this.trigger(this.state);
    }

    onRemove(product) {
        this.state.products = this.state.products.filter(currentValue => currentValue.id !== product.id);

        delete this.state.matrix[product.id];
        Object.keys(this.state.matrix).forEach((key) => {
            delete this.state.matrix[key][product.id]
        });
        this.state.error = null;

        this.trigger(this.state);
    }

    onError(message) {
        this.state.error = message;
        this.trigger(this.state);
    }

    onClearError() {
        this.onError(null);
    }
}

export default function create(initialState) {
    const store = new CompareStore();
    store.onLoad(initialState);

    return store;
}



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductCompare/Stores/CompareStore.jsx